/**
 *
 * @module customerServiceClientEndpoint
 * @see https://github.com/STRML/keyMirror
 *
 */

/* eslint new-cap: 'off' */

import KeyMirror from 'keymirror';

/**
 *
 * @typedef CustomerServiceClientEndpoint
 * @type {Object}
 *
 * @property {String} createSupportCode
 *
 */

/**
 *
 * @enum
 * @type {CustomerServiceClientEndpoint}
 *
 */
export default KeyMirror({
    /**
     *
     * @access public
     * @type {String}
     *
     */
    createSupportCode: null
});



// WEBPACK FOOTER //
// ./src/services/customerService/customerServiceClientEndpoint.js